module.exports = __webpack_public_path__ + "static/media/cloud-rainbow.02f0cd1a.svg";